module.exports = __webpack_public_path__ + "static/media/kardapen-web.56ac998b.svg";